module.exports = __webpack_public_path__ + "static/assets/905a8df081a605bdab90bedff54a82ad.svg";